var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 29.3337H20.0013C26.668 29.3337 29.3346 26.667 29.3346 20.0003V12.0003C29.3346 5.33366 26.668 2.66699 20.0013 2.66699H12.0013C5.33464 2.66699 2.66797 5.33366 2.66797 12.0003V20.0003C2.66797 26.667 5.33464 29.3337 12.0013 29.3337Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 24.6663C22.1333 24.6663 23.3333 23.4663 23.3333 21.9997V9.99967C23.3333 8.53301 22.1333 7.33301 20.6667 7.33301C19.2 7.33301 18 8.53301 18 9.99967V21.9997C18 23.4663 19.1867 24.6663 20.6667 24.6663Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 24.667C12.8013 24.667 14.0013 23.467 14.0013 22.0003V17.3337C14.0013 15.867 12.8013 14.667 11.3346 14.667C9.86797 14.667 8.66797 15.867 8.66797 17.3337V22.0003C8.66797 23.467 9.85464 24.667 11.3346 24.667Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.fb05ca0c07365396f67dd068a8ce0c6d.svg";
export { ForwardRef as ReactComponent };